import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import DeleteAccountModal from './DeleteAccountModal';
import ChangePasswordModal from './ChangePasswordModal';

const AccountSettings = () => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const { user } = useAuth();

  return (
    <div className="space-y-8">
      {/* Password Change Section */}
      <div>
        <h3 className="text-lg font-semibold mb-4">Change Password</h3>
        <p className="text-content-secondary mb-4">
          Keep your account secure by using a strong password that you don't use elsewhere.
        </p>
        <button
          onClick={() => setIsPasswordModalOpen(true)}
          className="btn-primary"
        >
          Change Password
        </button>
      </div>

      <hr className="border-gray-800" />

      {/* Delete Account Section */}
      <div>
        <h3 className="text-lg font-semibold text-red-500 mb-4">Delete Account</h3>
        <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-4 mb-4">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-red-500 mt-0.5" />
            <div>
              <p className="text-red-500 font-medium">Warning: This action cannot be undone</p>
              <p className="text-content-secondary mt-1">
                Deleting your account will:
              </p>
              <ul className="list-disc list-inside text-content-secondary mt-2 space-y-1">
                <li>Remove all your personal information</li>
                <li>Delete your profile and settings</li>
                <li>Remove your comments and submissions</li>
                <li>Cancel any active subscriptions</li>
              </ul>
            </div>
          </div>
        </div>
        <button
          onClick={() => setIsDeleteModalOpen(true)}
          className="px-4 py-2 bg-red-500/10 text-red-500 rounded-lg hover:bg-red-500/20 transition-colors"
        >
          Delete Account
        </button>
      </div>

      {/* Modals */}
      <ChangePasswordModal
        isOpen={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
      />
      <DeleteAccountModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      />
    </div>
  );
};

export default AccountSettings;